import React, { useState } from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { CheckButton, SignaturePopup } from '@apply/components';
import parse from 'html-react-parser';
import { isMobileScreen } from '@apply/ui';

export const ESignAgreementField: React.FC = () => {
    const mobileScreen = isMobileScreen();
    const eSignAgreement = useBrokerDetailsStore((s) => s.eSignAgreement);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const firstName = useBrokerDetailsStore((s) => s.firstName);
    const lastName = useBrokerDetailsStore((s) => s.lastName);
    const userAgreementHtml = useBrokerDetailsStore((s) => s.userAgreementHtml);
    const FONT_ID: string = '1';

    const [openESignModal, set_openESignModal] = useState(false);

    const handleESignChange = () => {
        if (eSignAgreement) {
            updateFields({ eSignAgreement: false });
        } else {
            set_openESignModal(true);
        }
    };

    const handleESignConfirm = () => {
        updateFields({ eSignFont: FONT_ID, eSignAgreement: true });
        set_openESignModal(false);
    };

    const handleESignCancel = () => {
        updateFields({ eSignAgreement: false });
        set_openESignModal(false);
    };

    return (
        <>
            <CheckButton
                id='eSignAgreement'
                selected={eSignAgreement}
                onToggle={() => handleESignChange()}
                label='Consent to Use Electronic Records and Disclosures. By checking this check box
                and clicking "SAVE", I acknowledge that I have read and agree on behalf of the
                Business Entities to the Consent to Use Electronic Records and Disclosures.'
                width={mobileScreen ? '100%' : '400px'}
            />
            <SignaturePopup
                id='eSignAgreementPopup'
                isOpen={openESignModal}
                onSubmitAgreement={handleESignConfirm}
                onDeclineAgreement={handleESignCancel}
                firstName={firstName}
                lastName={lastName}
            >
                {parse(userAgreementHtml ?? '')}
            </SignaturePopup>
        </>
    );
};
